/**
 * MovimentoRaiz — Motion na raiz do painel (decisão M4 b), uma vez.
 *
 *  - LazyMotion `strict`: os componentes usam `m.div` (não `motion.div`) e os recursos (layout e
 *    arraste) chegam depois, à parte (lib/movimentoRecursos.ts).
 *  - MotionConfig `reducedMotion`: com "reduzir movimento" no sistema, o Motion não anima
 *    transform nem layout (opacidade e cor continuam, decisão M2 b). Com a opção do produto
 *    (<html data-movimento="reduzido">), vale sempre.
 */
import type { ReactNode } from 'react';
import { LazyMotion, MotionConfig } from 'motion/react';

const carregarRecursos = (): Promise<typeof import('../../lib/movimentoRecursos').default> =>
  import('../../lib/movimentoRecursos').then((m) => m.default);

export function MovimentoRaiz({ children }: { children: ReactNode }): JSX.Element {
  const reduzidoNoProduto =
    typeof document !== 'undefined' && document.documentElement.dataset.movimento === 'reduzido';
  return (
    <LazyMotion features={carregarRecursos} strict>
      <MotionConfig reducedMotion={reduzidoNoProduto ? 'always' : 'user'}>{children}</MotionConfig>
    </LazyMotion>
  );
}
